
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import notifications from "../../../lib/notifications";
import {
  SetBulkOrderWantsAsapRequest,
  SetBulkOrderWantsAsapResult
} from "../../../models/api/orders/setBulkOrdersWantsAsap";
import moment from "moment";
import * as modals from "@/lib/modals";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.setBulkOrdersWantsAsapModal
})
export default class SetBulkOrdersWantsAsapModal extends Mixins(mixin) {
  loading: boolean = true;
  saving: boolean = false;
  value: boolean = true;

  load() {
    this.show();
    this.loading = false;
  }

  async saveModal() {
    const orderHeaderNumbers = [];
    this.saving = true;
    this.selectedItems.forEach(order => {
      orderHeaderNumbers.push(order.headerNumber);
    });
    const request = { orderHeaderNumbers: orderHeaderNumbers, value: this.value };
    try {
      const results = await orderModule.setBulkOrderWantsAsap(request);
      results.forEach(result => {
        this.addActionResult({
          number: result.orderHeaderNumber,
          success: result.successful,
          message: result.message
        });
      });
      this.hideModal();
    } catch (ex) {
      notifications.error("Set Wants ASAP", "Failed to set Wants ASAP flag", ex);
    }

    this.refreshOrders();
    this.saving = false;
  }

  hide() {
    this.loading = true;
    this.value = true;
  }

  getBooleanOptions() {
    return [
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
